import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { AppRoutingModule } from './app-routing/app-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule} from '@angular/material/toolbar'; 
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatListModule} from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule} from '@angular/material/card';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RecaptchaFormsModule,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module
} from 'ng-recaptcha';

import { ConfirmationComponent } from './shared/modals/confirmation/confirmation.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { LoadingComponent } from './shared/modals/loading/loading.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DialogComponent } from './shared/modals/dialog/dialog.component';
import { PrivacyDialogComponent } from './shared/modals/privacy-dialog/privacy-dialog.component';
import { LocationinfoComponent } from './shared/modals/locationinfo/locationinfo.component';
import { UcdhinfoComponent } from './shared/modals/ucdhinfo/ucdhinfo.component';
import { PeopleDetailsComponent } from './people-details/people-details.component';
import { PeopleListComponent } from './people-list/people-list.component';
import { NgxVcardModule } from 'ngx-vcard';
import { HowToSearchPeopleComponent } from './how-to-search-people/how-to-search-people.component';
import { HowToSearchDepartmentsComponent } from './how-to-search-departments/how-to-search-departments.component';
import { PeopleListingHelpComponent } from './people-listing-help/people-listing-help.component';
import { HelpComponent } from './help/help.component';
import { DeptListingSearchResultsComponent } from './dept-listing-search-results/dept-listing-search-results.component';
import { DeptListingDetailComponent } from './dept-listing-detail/dept-listing-detail.component';
import { SpacesComponent } from './shared/components/spaces/spaces.component';
import { RouterExtService } from './shared/routerext.service';
import { AbbreviationsComponent } from './abbreviations/abbreviations.component';
import { GuidelinesComponent } from './guidelines/guidelines.component';
import { environment } from 'src/environments/environment';

const RECAPTCHA_V3_STACKBLITZ_KEY = '6LeHBK0bAAAAAOQVTvBOWhfb08cQfUpFoSE3FsmP';
const RECAPTCHA_V2_DUMMY_KEY = environment.sitekey;


@NgModule({
  declarations: [
    AppComponent,
    ConfirmationComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoadingComponent,
    DialogComponent,
    PrivacyDialogComponent,
    LocationinfoComponent,
    UcdhinfoComponent,
    PeopleDetailsComponent,
    PeopleListComponent,
    HowToSearchPeopleComponent,
    HowToSearchDepartmentsComponent,
    PeopleListingHelpComponent,
    HelpComponent,
    DeptListingSearchResultsComponent,
    DeptListingDetailComponent,
    SpacesComponent,
    PeopleListComponent,
    PeopleDetailsComponent,
    AbbreviationsComponent,
    GuidelinesComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    CommonModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatToolbarModule,
    AppRoutingModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatTabsModule,
    MatCardModule,
    MatGridListModule,
    MatCheckboxModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    MatTooltipModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatMenuModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module,
    NgxVcardModule
  ],
  providers: [RouterExtService, {provide: LocationStrategy, useClass: HashLocationStrategy},
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: RECAPTCHA_V2_DUMMY_KEY
      } as RecaptchaSettings
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(private routerExtService: RouterExtService){}
}